// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 231) return "static/chunks/231-263245607b952547.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"390":"d648eb28","690":"8cc6faea","4574":"074562c2"}[chunkId] || chunkId) + "." + {"390":"1d205953404745de","687":"c1fefad1782ebd58","690":"79633feff3f6f090","2166":"6ded6e6a597a6614","4574":"9bc86f7b91989289"}[chunkId] + ".js";
};